export const convertTimeMessage = (time: string) => {
	const date = new Date(time).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
	const hours = date.split(":")[0];
	const minutes = date.split(":")[1];

	return `${hours}:${minutes}`;
};

const listDomainZone = [
	"com",
	"org",
	"net",
	"info",
	"biz",
	"name",
	"edu",
	"gov",
	"mil",
	"int",
	"aero",
	"jobs",
	"mobi",
	"museum",
	"coop",
	"travel",
	"app",
	"blog",
	"shop",
	"xyz",
	"tech",
	"online",
	"arpa",
	"io",
	"site",
	"space",
	"live",
	"fun",
	"club",
	"store",
	"games",
	"art",
];
const listCountryDomain = [
	"us",
	"uk",
	"de",
	"fe",
	"ru",
	"cn",
	"jp",
	"ca",
	"in",
	"br",
	"au",
	"fr",
	"id",
	"it",
	"gl",
	"es",
	"mx",
	"nl",
	"se",
	"pl",
	"tr",
	"kr",
	"sg",
	"za",
];

const combinedDomainZones = listDomainZone.concat(listCountryDomain);
const domainZonePattern = combinedDomainZones.join("|");

const urlRegex = new RegExp(
	`((https?:\\/\\/)?[\\w.-]+\\.(${domainZonePattern})([\\w\\-.~:/?#[\\]@!$&'()*+,;=%]*)?)`,
	"gi",
);

export const linkText = (text: string, isCompanionMessage: boolean, onOpenLinkDialog: (href: string) => void) => {
	const className = isCompanionMessage
		? "cursor-pointer underline text-primary"
		: "cursor-pointer underline text-white";

	const parts = [];
	let lastIndex = 0;
	const matches = [...text.matchAll(urlRegex)];

	matches.forEach((match) => {
		const url = match[0];
		const offset = match.index || 0;

		if (lastIndex < offset) {
			parts.push(text.slice(lastIndex, offset));
		}

		const href = url.startsWith("http://") || url.startsWith("https://") ? url : `http://${url}`;

		parts.push(
			<span key={href + offset} onClick={() => onOpenLinkDialog(href)} className={className}>
				{url}
			</span>,
		);

		lastIndex = offset + url.length;
	});

	if (lastIndex < text.length) {
		parts.push(text.slice(lastIndex));
	}

	return <>{parts}</>;
};
